import axios from "axios";

export interface BrasilApiBank {
  ispb: string;
  name: string;
  code: number | null;
  fullName: string;
}

const BRASIL_API_BASE_URL = "https://brasilapi.com.br/api";

/**
 * Serviço para integração com a Brasil API
 * Documentação: https://brasilapi.com.br/docs#tag/BANKS
 */
export const brasilApiService = {
  /**
   * Busca lista de bancos da Brasil API
   * @returns Lista de bancos filtrados e ordenados
   */
  async getBanks(): Promise<BrasilApiBank[]> {
    try {
      const response = await axios.get<BrasilApiBank[]>(`${BRASIL_API_BASE_URL}/banks/v1`, {
        timeout: 10000, // 10 segundos de timeout
      });
      // Filtrar apenas bancos com código válido e ordenar por nome
      return response.data
        .filter((bank) => bank.code != null && bank.name)
        .sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.status === 404
            ? "Endpoint de bancos não encontrado na Brasil API"
            : error.response?.status === 500
              ? "Erro no servidor da Brasil API"
              : `Erro ao buscar bancos: ${error.message}`,
        );
      }
      throw new Error("Erro desconhecido ao buscar bancos");
    }
  },
};

